(() => {
  if (window.dpPrisjaktCheapestBound) return;
  window.dpPrisjaktCheapestBound = true;
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
    const section = input.closest('.shopify-section');
    if (!section || !/^\d+$/.test(input.value)) return;
    let changed = false;
    section.querySelectorAll('.dp-prisjakt-cheapest').forEach((region) => {
      const marker = region.querySelector('.prisjakt_cheapest');
      if (!marker || marker.dataset.product === input.value) return;
      const next = region.cloneNode(false);
      const nextMarker = marker.cloneNode(false);
      nextMarker.dataset.product = input.value;
      next.append(nextMarker);
      region.replaceWith(next);
      changed = true;
    });
    if (changed && window.prisjakt_cheapest) window.prisjakt_cheapest.reload();
  });
})();
